import { supabase } from '@/integrations/supabase/client';

export interface EmailLogRow {
  id: string;
  tenant_id: string | null;
  recipient_email: string;
  recipient_user_id: string | null;
  email_type: string;
  subject: string;
  body_html: string | null;
  status: 'queued' | 'sent' | 'failed';
  error_message: string | null;
  provider: string | null;
  provider_message_id: string | null;
  sent_by_user_id: string | null;
  metadata: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
}

export interface EmailLogFilters {
  tenant_id?: string;
  recipient_email?: string;
  recipient_user_id?: string;
  email_type?: string;
  status?: 'queued' | 'sent' | 'failed';
  limit?: number;
  offset?: number;
}

export async function fetchEmailLogs(
  filters: EmailLogFilters = {}
): Promise<{ rows: EmailLogRow[]; total: number }> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const client = supabase as any;
  let query = client
    .from('email_log')
    .select('*', { count: 'exact' })
    .order('created_at', { ascending: false });

  if (filters.tenant_id) query = query.eq('tenant_id', filters.tenant_id);
  if (filters.recipient_email) query = query.ilike('recipient_email', `%${filters.recipient_email}%`);
  if (filters.recipient_user_id) query = query.eq('recipient_user_id', filters.recipient_user_id);
  if (filters.email_type && filters.email_type !== 'all') query = query.eq('email_type', filters.email_type);
  if (filters.status && filters.status !== 'all') query = query.eq('status', filters.status);

  const limit = filters.limit ?? 50;
  const offset = filters.offset ?? 0;
  query = query.range(offset, offset + limit - 1);

  const { data, error, count } = await query;
  if (error) {
    console.error('fetchEmailLogs error:', error);
    return { rows: [], total: 0 };
  }

  return { rows: (data ?? []) as EmailLogRow[], total: count ?? 0 };
}
